export class UserLogin {
    constructor (
        public _id: String,
        public emailNick: String,
        public password: String,
        public gettoken: String
    ) {}
}
